import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { AW_NEWS_API_URL } from './Constants';
import {
  AGraphNewsSummaryLROResponse,
  AGraphNewsSummaryResponse,
  BatchNewsSummaryResponse,
  NewsSummaryRequest,
} from './types';

export const awNewsApi = axios.create();

export const awNewsSettings: AGraphApiSettings = {};

awNewsApi.interceptors.request.use((config) => {
  const { getConfigurationDirectoryFn, getAladdinApiKey, getEnvTypeFn } = awNewsSettings;
  const baseURL = AW_NEWS_API_URL;
  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    data: {
      ...config.data,
      overrideConfigDirectory: getConfigurationDirectoryFn?.(),
    },
  };
  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), getEnvTypeFn?.());
  return updatedConfig;
});

// get news insight by LRO id
export const getNewsSummaryResponse = (id: string): Promise<AxiosResponse<AGraphNewsSummaryLROResponse>> =>
  awNewsApi.get(`/v1/longRunningOperations/${id}`);

// get one LRO id
export const postNewsSummaryId = (request: NewsSummaryRequest): Promise<AxiosResponse<AGraphNewsSummaryResponse>> =>
  awNewsApi.post('/v1/newsSummaries:generateNewsSummary', { ...request });

// batch generate news summaries - returns array of LRO ids
export const postBatchNewsSummaries = (
  requests: NewsSummaryRequest[]
): Promise<AxiosResponse<BatchNewsSummaryResponse>> => awNewsApi.post('/v1/newsSummaries:generate', { requests });
